import { placeLabel } from '@carcheck/shared';

/** The place fields an admin response may carry (older bodies omit all but `city`). */
interface PlaceCarrier {
  city?: string | null | undefined;
  cityCountry?: string | null | undefined;
  cityCountryName?: string | null | undefined;
}

/** «Минск» in Belarus, «Сеул, Корея» abroad; `null` — no city. */
export const placeText = (p: PlaceCarrier): string | null =>
  placeLabel({
    city: p.city ?? null,
    cityCountry: p.cityCountry ?? null,
    cityCountryName: p.cityCountryName ?? null,
  });
